import { isNull } from 'lodash-es';
import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MobxContext } from 'shared/lib/contexts/mobxContext';

export const useSsoAuth = () => {
  const [searchParams] = useSearchParams();

  const accessToken = searchParams.get('access_token');

  const {
    mobxStore: { authStore },
  } = useContext(MobxContext);

  if (!isNull(accessToken)) {
    authStore.forceLogin(accessToken);

    searchParams.delete('access_token');
  }

  return null;
};
